import { useEffect } from "react";
import { BASE_PATH } from "../utils/basePath";

export default function LoginSSORedirect() {
  useEffect(() => {
    // Check if user is already authenticated via URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const isAlreadyAuthenticated = urlParams.get('auth') === 'already_authenticated';
    
    if (isAlreadyAuthenticated) {
      console.log('🔐 User already authenticated, redirecting to dashboard');
      window.location.href = `${BASE_PATH}/loans`;
      return;
    }
    
    // Only redirect to Salesforce OAuth if not already authenticated
    console.log('🔐 Redirecting to Salesforce OAuth login');
    window.location.href = `${BASE_PATH}/api/salesforce/salesforce-login-oauth`;
  }, []);
  
  return null;
} 